const API_BASE_URL_OVERRIDE = '';

export const API_BASE_URL = API_BASE_URL_OVERRIDE || process.env.REACT_APP_API_URL || '';

export const KRISHI_ORG_ID = 'a7ef62fe-1228-4a83-976f-fd1a03d19844';

export const LOGIN_PLATFORM = 'deletion';

// The one path that renders this page. Published on the Play Store listing.
export const ROUTE_PATH = '/krishi/deleteAccount';

export const SUPPORT_EMAIL = 'farmlogics.tech@gmail.com';

export const APP_NAME = 'Krishi';
export const DEVELOPER_NAME = 'Farmlogics';

export const OTHER_REASON_KEY = 'other';
export const REASONS = [
    { key: 'not_using', label: 'I no longer use this app' },
    { key: 'app_issues', label: 'The app is hard to use or has problems' },
    { key: 'privacy', label: 'I have privacy concerns about my data' },
    { key: 'duplicate', label: 'I have another account' },
    { key: OTHER_REASON_KEY, label: 'Other reason' },
];

export const REASON_MIN_LEN = 5;
export const REASON_MAX_LEN = 500;

// Without an org id the gate restricts nobody; without a base URL every request
// hits the page's own origin. Either missing means refuse to run.
export const isOrgIdConfigured = () =>
    typeof KRISHI_ORG_ID === 'string' &&
    KRISHI_ORG_ID.trim() !== '' &&
    KRISHI_ORG_ID !== 'REPLACE_WITH_KRISHI_ORG_ID' &&
    typeof API_BASE_URL === 'string' &&
    API_BASE_URL.trim() !== '';

// Exact match only — this one path renders the page and nothing else does.
// "/krishi" alone, or any other path under it, falls through to FlowForms.
// Trailing slash is tolerated because the dev server 301-redirects to add one;
// case is ignored so a mistyped capital does not dead-end a real user.
export const isKrishiDeletionRoute = (pathname) => {
    if (typeof pathname !== 'string') return false;
    return pathname.replace(/\/+$/, '').toLowerCase() === ROUTE_PATH.toLowerCase();
};
